import * as types from "../../mutation-types";
import {DateTime} from "luxon";

const state = {
	orderControlPanel: {
		orderSearch: "",
		startDate: DateTime.now().minus({days: 1}).toFormat("yyyy-MM-dd"),
		endDate: DateTime.now().toFormat("yyyy-MM-dd"),
		refundPassword: "",
		visibleColumns: ["orderNumber", "status", "totalPrice", "paymentDialogs", "shopNumber", "pickupDate", "actions"],
		openedSection: {
			conditionsSection: true,
			orderNumberSection: false
		},
		tenantSelected: 0,
		paymentFilterSelected: "all"
	}
};
const getters = {
	orderControlPanelSearch: state => state.orderControlPanel.orderSearch,
	orderControlPanelStartDate: state => state.orderControlPanel.startDate,
	orderControlPanelEndDate: state => state.orderControlPanel.endDate,
	orderControlPanelRefundPassword: state => state.orderControlPanel.refundPassword,
	orderControlPanelVisibleColumns: state => state.orderControlPanel.visibleColumns || [],
	orderControlPanelOpenedSection: state => state.orderControlPanel.openedSection,
	orderControlPanelTenantSelected: state => state.orderControlPanel.tenantSelected,
	orderControlPanelPaymentFilterSelected: state => state.orderControlPanel.paymentFilterSelected
};
const actions = {

};
const mutations = {
	[types.UPDATE_ORDER_CONTROL_PANEL_DATA](state, data = {}) {
		state.orderControlPanel = Object.assign(state.orderControlPanel, data);
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
